import { useCallback, useEffect, useState } from 'react';
const messageOf = (e) => (e instanceof Error ? e.message : 'unknown error');
export function useResource(fetcher, deps = []) {
    const [load, setLoad] = useState({ kind: 'loading' });
    const [nonce, setNonce] = useState(0);
    const reload = useCallback(() => {
        setLoad({ kind: 'loading' });
        setNonce((n) => n + 1);
    }, []);
    useEffect(() => {
        let live = true;
        fetcher()
            .then((data) => { if (live)
            setLoad({ kind: 'ready', data }); })
            .catch((e) => { if (live)
            setLoad({ kind: 'error', message: messageOf(e) }); });
        return () => { live = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, nonce]);
    return { load, reload };
}
/**
 * A write plus the reload that follows it. Returns the error rather than throwing, because every
 * caller of this was already catching to put a message on screen.
 */
export function useAction(reload) {
    const [busy, setBusy] = useState(false);
    const [failure, setFailure] = useState(null);
    const run = useCallback(async (work) => {
        setBusy(true);
        setFailure(null);
        try {
            await work();
            reload?.();
            return true;
        }
        catch (e) {
            setFailure(messageOf(e));
            return false;
        }
        finally {
            setBusy(false);
        }
    }, [reload]);
    return { busy, failure, run };
}
//# sourceMappingURL=index.js.map